var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7512 16.7543H14.7525V13.6215C14.7525 12.8745 14.7375 11.913 13.71 11.913C12.6682 11.913 12.5092 12.726 12.5092 13.5667V16.7543H10.5097V10.3125H12.4297V11.19H12.456C12.7245 10.6845 13.377 10.1497 14.352 10.1497C16.377 10.1497 16.752 11.4832 16.752 13.218V16.7543H16.7512ZM8.25225 9.43125C8.09967 9.43145 7.94854 9.40153 7.80755 9.3432C7.66655 9.28488 7.53845 9.1993 7.43059 9.09138C7.32273 8.98345 7.23724 8.85529 7.17901 8.71426C7.12078 8.57322 7.09095 8.42208 7.09125 8.2695C7.0914 8.03988 7.15963 7.81545 7.28733 7.62461C7.41503 7.43377 7.59645 7.28508 7.80865 7.19734C8.02085 7.1096 8.2543 7.08676 8.47949 7.13171C8.70467 7.17665 8.91147 7.28736 9.07373 7.44983C9.23599 7.6123 9.34644 7.81925 9.39109 8.04449C9.43574 8.26973 9.4126 8.50315 9.32459 8.71524C9.23658 8.92733 9.08765 9.10855 8.89664 9.236C8.70564 9.36345 8.48112 9.4314 8.2515 9.43125H8.25225ZM9.25425 16.7543H7.2495V10.3125H9.255V16.7543H9.25425ZM17.7525 5.25H6.24675C5.69475 5.25 5.25 5.685 5.25 6.22275V17.7772C5.25 18.315 5.6955 18.75 6.246 18.75H17.7495C18.3 18.75 18.75 18.315 18.75 17.7772V6.22275C18.75 5.685 18.3 5.25 17.7495 5.25H17.7518H17.7525Z",
    fill: "#0E76A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.3e9c9c5841be5815bc92895f64a7edaa.svg";
export { ForwardRef as ReactComponent };